<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="minimize_black_24dp (1) 1" clip-path="url(#clip0_3002_15858)">
<path id="Vector" d="M3 9.5H9V10.5H3V9.5Z" fill="#888888"/>
</g>
<defs>
<clipPath id="clip0_3002_15858">
<rect width="12" height="12" fill="white"/>
</clipPath>
</defs>
</svg>
